import ProductGrid from "./product-grid";

export default ProductGrid;